import { createReducer, on } from '@ngrx/store';
import * as EmployeeRoleActions from './employee-roles.actions';
import { EmployeeRole } from './employee-roles.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface EmployeeRolesState {
    roles: EmployeeRole[];
    role: EmployeeRole | null;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialEmployeeRolesState: EmployeeRolesState = {
    roles: [],
    role: null,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// All EmployeeRoles Reducer
export const employeeRolesReducer = createReducer(
    initialEmployeeRolesState,

    // On Load EmployeeRoles
    on(EmployeeRoleActions.loadEmployeeRoles, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(EmployeeRoleActions.loadEmployeeRolesSuccess, (state, { roles }) => ({
        ...state,
        isLoading: false,
        roles: roles,
    })),
    on(EmployeeRoleActions.loadEmployeeRolesFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Single EmployeeRole
    on(EmployeeRoleActions.loadEmployeeRole, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(EmployeeRoleActions.loadEmployeeRoleSuccess, (state, { role }) => ({
        ...state,
        isLoading: false,
        role: role,
    })),
    on(EmployeeRoleActions.loadEmployeeRoleFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Create
    on(EmployeeRoleActions.createEmployeeRole, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(EmployeeRoleActions.createEmployeeRoleSuccess, (state, { role }) => ({
        ...state,
        isLoading: false,
        roles: [...state.roles, role],
    })),
    on(EmployeeRoleActions.createEmployeeRoleFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Update
    on(EmployeeRoleActions.updateEmployeeRole, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(EmployeeRoleActions.updateEmployeeRoleSuccess, (state, { role }) => ({
        ...state,
        isLoading: false,
        roles: state.roles.map((r) => (r.id === role.id ? role : r)),
    })),
    on(EmployeeRoleActions.updateEmployeeRoleFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Delete
    on(EmployeeRoleActions.deleteEmployeeRole, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(EmployeeRoleActions.deleteEmployeeRoleSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        roles: state.roles.filter((r) => r.id !== id),
    })),
    on(EmployeeRoleActions.deleteEmployeeRoleFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);
